export default __webpack_public_path__ + "static/media/Breast of the Warded Brute.22da6a69.jpg";